    <div class="card">
    <div class="card-header flex">
        <h2>{{ 'offers.preview.phases.heading.evolution' | translate }}</h2>

        <button class="button button-primary" (click)="onAddPhase()" [disabled]="isCompleted()">
            {{ 'shared.button.add' | translate }}
        </button>
    </div>
    <div class="card-body" style="padding: 0">
        <div class="scope-phases-empty" *ngIf="!phases.length">
            <div>
                <p>{{ 'offers.preview.phases.empty' | translate }}</p>
            </div>
        </div>

        <div class="scope-phases" *ngIf="phases.length">

            <!-- phase -->

            <div *ngFor="let phase of phases">

                <div *ngIf="phase" class="scope-phase-container" [ngClass]="{ 'scope-phase--next': phase.is_next, 'scope-phase--current': phase.is_current, 'scope-phase--ended': phase.is_ended, 'scope-phase--modified': !phase.cashback_rate }">

                    <i *ngIf="!phase.is_first" [class]="'i ' + getPhaseIconClass(phase)"></i>

                    <div class="scope-phase">
                        <div class="scope-phase-header">
                            <div class="scope-phase-header-date-start">
                                {{ phase.start_date | localizedDate : 'shortDate' }}
                            </div>
                            <div class="scope-phase-header-date-end">
                                {{ (phase.end_date | localizedDate : 'shortDate' ) || '∞' }}
                            </div>
                        </div>
                        <div class="scope-phase-body">
                            <div class="scope-phase-value">
                                {{ (phase.cashback_rate | localizedNumber : '1.0-2') || '--' }}%
                            </div>

                            <div class="scope-phase-percent" [ngStyle]="{ height: (phase.cashback_rate || phase.strategy?.playground?.max) + '%' }"></div>
                            <div>{{ 'shared.label.commission-max' | translate }} {{ phase.strategy?.playground?.max | localizedNumber : '1.0-2' }}%</div>
                        </div>

                        <div class="scope-overlay" *ngIf="!isCompleted()">
                            <button *ngIf="isDeletable(phase, phases)" class="scope-delete" (click)="onDeletePhase(phase)" [disabled]="isCompleted()">
                                <span>{{ 'offers.preview.phases.button.delete' | translate }}</span>
                            </button>

                            <button class="scope-edit" (click)="onEditPhase(phase)" [disabled]="isCompleted()">
                                <span *ngIf="!isEnded(phase)">{{ 'offers.preview.phases.button.adjust' | translate }}</span>
                                <span *ngIf="isEnded(phase)">{{ 'offers.preview.phases.button.details' | translate }}</span>
                            </button>
                        </div>

                        <div *ngIf="phase.is_current" class="scope-phase-arrow"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scope-phase-default">
            <table class="scope-phase-default-table" [ngClass]="{ 'scope-phas-default--current': defaultPhase.is_current }">
                <tr class="scope-phase-default-top">
                    <td>{{ (defaultPhase.start_date | localizedDate : 'shortDate' )}}</td>
                    <td>&nbsp;</td>
                    <td>{{ (defaultPhase.end_date | localizedDate : 'shortDate' ) || '∞' }}</td>
                </tr>
                <tr class="scope-phase-default-bottom">
                    <td colspan="3">
                        <strong>{{ (defaultPhase.cashback_rate  | localizedNumber : '1.0-2') || '--' }}%</strong>
                        <small>({{ 'shared.label.commission-max' | translate }} {{ defaultPhase.strategy?.playground?.max | localizedNumber : '1.0-2' }}%)</small>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
